import ReactGA from 'react-ga4';

export const sendGaEvent = (event) => {
  if (ReactGA?.event) {
    ReactGA.event(event);
  }
};
